import type { Product } from '../types/product';

/** Map a Supabase products row to our Product type. */
export function mapRowToProduct(row: {
  id: string;
  slug: string;
  name: string;
  description: string;
  type: string;
  price: number;
  original_price: number;
  tag: string | null;
  theme: string;
  image_url: string | null;
  audio_preview_url: string | null;
  audio_preview_title: string | null;
  audio_preview_duration: string | null;
  download_file_name: string | null;
  features: unknown;
  detailed_features: unknown;
  genres: unknown;
  specifications: unknown;
  is_free?: boolean;
}): Product {
  return {
    id: row.id,
    slug: row.slug,
    name: row.name,
    description: row.description,
    type: row.type as 'preset' | 'sample_pack' | 'template',
    price: Number(row.price),
    originalPrice: Number(row.original_price),
    isFree: row.is_free === true || Number(row.price) === 0,
    tag: row.tag ?? undefined,
    theme: row.theme as 'red' | 'blue',
    image: row.image_url ?? undefined,
    audioPreview: row.audio_preview_url
      ? {
          url: row.audio_preview_url,
          title: row.audio_preview_title ?? 'Audio Preview',
          duration: row.audio_preview_duration ?? '0:00',
        }
      : undefined,
    downloadFileName: row.download_file_name ?? undefined,
    features: Array.isArray(row.features) ? row.features : [],
    detailedFeatures: Array.isArray(row.detailed_features) ? row.detailed_features : [],
    genres: Array.isArray(row.genres) ? row.genres : [],
    specifications:
      typeof row.specifications === 'object' && row.specifications != null
        ? (row.specifications as Product['specifications'])
        : undefined,
  };
}
